document.addEventListener('DOMContentLoaded', function() {
  const filterBtn = document.querySelector('.collection-filter__btn');
  const filterCloseBtns = document.querySelectorAll('.collection-mobile-filters__close, .collection-mobile-filters__overlay');
  
  if (!filterBtn) return;

  function toggleWidgets(shouldHide) {
    const widgets = [
      document.getElementById('launcher'),
      document.querySelector('iframe[title*="messaging"]'),
      document.querySelector('.jsc-sticky-scroll-section')
    ];

    widgets.forEach(widget => {
      if (!widget) return;
      
      const targetEl = (widget.tagName === 'IFRAME' && widget.parentElement !== document.body) ? widget.parentElement : widget;

      if (shouldHide) {
        targetEl.style.setProperty('display', 'none', 'important');
      } else {
        targetEl.style.removeProperty('display');
      }
    });
  }

  filterBtn.addEventListener('click', function() {
    toggleWidgets(true);
  });
  filterCloseBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      setTimeout(() => toggleWidgets(false), 300);
    });
  });
});